import { IGetProductData } from '../../../api/getProducts/types';

export const titleCaseRecipeType = (recipeType: IGetProductData['type']): string => {
  return `${recipeType[0]}${recipeType.slice(1).toLowerCase()}`;
};
